import { render, staticRenderFns } from "./Vaccine.vue?vue&type=template&id=86e97724&"
import script from "./Vaccine.vue?vue&type=script&lang=js&"
export * from "./Vaccine.vue?vue&type=script&lang=js&"
import style0 from "./Vaccine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports